import { MeetingShare } from "@/schema"
import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchMeetingShares } from "./api"

export function useMeetingShares(meetingId: string) {
  const getContext = useApiContext()

  return useQuery<MeetingShare[], Error>({
    queryKey: ["meetingShares", meetingId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchMeetingShares(context, meetingId)
    },
    enabled: !!meetingId,
  })
}
